import React, { useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import carousel1 from '../assets/img/carousel-1.jpg';
import carousel2 from '../assets/img/carousel-2.jpg';
import about1 from '../assets/img/about-1.jpg';
import about2 from '../assets/img/about-2.jpg';
import about3 from '../assets/img/about-3.jpg';
import about4 from '../assets/img/about-4.jpg';
import logo1 from '../assets/img/com-logo-1.jpg';
import logo2 from '../assets/img/com-logo-2.jpg';
import logo3 from '../assets/img/com-logo-3.jpg';
import logo4 from '../assets/img/com-logo-4.jpg';
import logo5 from '../assets/img/com-logo-5.jpg';
import t1 from '../assets/img/testimonial-1.jpg';
import t2 from '../assets/img/testimonial-2.jpg';
import t3 from '../assets/img/testimonial-3.jpg';
import t4 from '../assets/img/testimonial-4.jpg';

const categories = [
  { icon: 'fa-mail-bulk',        label: 'Marketing',           count: 123, color: '#4f46e5' },
  { icon: 'fa-headset',          label: 'Customer Service',    count: 98,  color: '#0066FF' },
  { icon: 'fa-user-tie',         label: 'Human Resource',      count: 76,  color: '#00C896' },
  { icon: 'fa-tasks',            label: 'Project Management',  count: 54,  color: '#f59e0b' },
  { icon: 'fa-chart-line',       label: 'Business Dev',        count: 89,  color: '#ef4444' },
  { icon: 'fa-hands-helping',    label: 'Sales & Comm',        count: 112, color: '#8b5cf6' },
  { icon: 'fa-book-reader',      label: 'Teaching & Education',count: 67,  color: '#06b6d4' },
  { icon: 'fa-drafting-compass', label: 'Design & Creative',   count: 145, color: '#ec4899' },
];

const jobs = [
  { logo: logo1, title: 'Software Engineer',   location: 'New York, USA', type: 'Full Time',  salary: '₹120k - ₹160k', deadline: '01 Jan, 2045', tag: 'Featured' },
  { logo: logo2, title: 'Marketing Manager',   location: 'London, UK',    type: 'Full Time',  salary: '₹80k - ₹110k',  deadline: '01 Jan, 2045', tag: 'Hot' },
  { logo: logo3, title: 'Product Designer',    location: 'Remote',        type: 'Part Time',  salary: '₹60k - ₹90k',   deadline: '01 Jan, 2045', tag: 'New' },
  { logo: logo4, title: 'Creative Director',   location: 'Dubai, UAE',    type: 'Full Time',  salary: '₹100k - ₹140k', deadline: '01 Jan, 2045', tag: 'Featured' },
  { logo: logo5, title: 'WordPress Developer', location: 'Toronto, CA',   type: 'Freelance',  salary: '₹50k - ₹75k',   deadline: '01 Jan, 2045', tag: 'New' },
];

const testimonials = [
  { img: t1, text: 'JobEntry helped me land my dream role in just 2 weeks. The platform is incredibly easy to use and the job matches were spot on!', name: 'Sarah Johnson', profession: 'UX Designer at Google' },
  { img: t2, text: 'As an employer, I found top-quality candidates faster than any other platform. Highly recommend JobEntry to every hiring manager.', name: 'Michael Chen', profession: 'CTO at TechCorp' },
  { img: t3, text: 'The one-click apply feature saved me so much time. I got 5 interview calls within the first week of signing up!', name: 'Priya Sharma', profession: 'Data Analyst at Amazon' },
  { img: t4, text: 'Clean interface, great filters, and real job listings. JobEntry is the only job portal I use now.', name: 'James Williams', profession: 'Product Manager at Meta' },
];

const slides = [
  { img: carousel1, badge: '🚀 #1 Job Portal', title: 'Find The Perfect Job\nThat You Deserved', desc: 'Connect with 50,000+ companies and discover opportunities that match your skills, passion, and career goals.' },
  { img: carousel2, badge: '💼 Trusted by 120K+ Seekers', title: 'Land Your Dream\nStartup Job Today', desc: 'From Fortune 500 to fast-growing startups — find the role that launches your next chapter.' },
];

const stats = [
  { icon: 'fa-briefcase',  num: '50K+',  label: 'Jobs Posted' },
  { icon: 'fa-users',      num: '120K+', label: 'Job Seekers' },
  { icon: 'fa-building',   num: '8K+',   label: 'Companies' },
  { icon: 'fa-handshake',  num: '35K+',  label: 'Hired' },
];

const tabs = ['All Jobs', 'Full Time', 'Part Time'];

export default function Home() {
  const [activeTab, setActiveTab] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [category, setCategory] = useState('');
  const [location, setLocation] = useState('');
  const { user } = useAuth();

  const filtered = jobs.filter(j => {
    const matchTab = activeTab === 0 || j.type === tabs[activeTab];
    const matchKey = j.title.toLowerCase().includes(keyword.toLowerCase());
    return matchTab && matchKey;
  });

  const heroSettings = {
    dots: true, infinite: true, speed: 800, slidesToShow: 1,
    slidesToScroll: 1, autoplay: true, autoplaySpeed: 5000, arrows: false,
    appendDots: dots => <div className="hero-dots">{dots}</div>,
  };

  const testimonialSettings = {
    dots: true, infinite: true, speed: 600, slidesToShow: 3,
    slidesToScroll: 1, autoplay: true, autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      {/* Hero */}
      <section className="hero-section">
        <Slider {...heroSettings}>
          {slides.map((s, i) => (
            <div key={i}>
              <div className="hero-slide" style={{ backgroundImage: `url(${s.img})` }}>
                <div className="hero-overlay">
                  <div className="container">
                    <div className="hero-content">
                      <span className="hero-badge">{s.badge}</span>
                      <h1 className="hero-title">{s.title.split('\n').map((line, j) => <span key={j}>{line}<br /></span>)}</h1>
                      <p className="hero-desc">{s.desc}</p>
                      <div className="hero-actions">
                        <Link to="/job-list" className="hero-btn-primary"><i className="fa fa-search me-2"></i> Browse Jobs</Link>
                        <Link to="/post-job" className="hero-btn-outline"><i className="fa fa-user-plus me-2"></i> Post a Job</Link>
                      </div>
                      <div className="hero-trust">
                        <div className="trust-avatars">
                          {[t1,t2,t3,t4].map((img,j) => <img key={j} src={img} alt="" />)}
                        </div>
                        <span><strong>120,000+</strong> professionals already joined</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Search Card */}
        <div className="hero-search-card">
          <div className="container">
            <div className="search-card">
              <div className="search-card-inner">
                <div className="search-field">
                  <label><i className="fa fa-search me-2 text-primary"></i>Job Title</label>
                  <input type="text" placeholder="e.g. Software Engineer" value={keyword} onChange={e => setKeyword(e.target.value)} />
                </div>
                <div className="search-sep"></div>
                <div className="search-field">
                  <label><i className="fa fa-th-large me-2 text-primary"></i>Category</label>
                  <select value={category} onChange={e => setCategory(e.target.value)}>
                    <option value="">All Categories</option>
                    {categories.map((c,i) => <option key={i}>{c.label}</option>)}
                  </select>
                </div>
                <div className="search-sep"></div>
                <div className="search-field">
                  <label><i className="fa fa-map-marker-alt me-2 text-primary"></i>Location</label>
                  <select value={location} onChange={e => setLocation(e.target.value)}>
                    <option value="">All Locations</option>
                    <option>New York, USA</option>
                    <option>London, UK</option>
                    <option>Remote</option>
                    <option>Dubai, UAE</option>
                  </select>
                </div>
                <Link to="/job-list" className="search-card-btn"><i className="fa fa-search me-2"></i> Search Jobs</Link>
              </div>
              <div className="search-tags">
                <span>Popular:</span>
                {['UI Designer', 'React Developer', 'Data Analyst', 'Product Manager', 'DevOps'].map((t,i) => (
                  <button key={i} className="search-tag">{t}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((s, i) => (
              <div className="stat-card" key={i}>
                <div className="stat-icon"><i className={`fa ${s.icon}`}></i></div>
                <div>
                  <div className="stat-number">{s.num}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Browse by Field</span>
            <h2 className="section-title">Explore By Category</h2>
            <p className="section-sub">Find the right opportunity in your area of expertise</p>
          </div>
          <div className="row g-4">
            {categories.map((cat, i) => (
              <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                <Link to="/job-list" className="cat-card">
                  <div className="cat-icon-wrap" style={{ background: cat.color + '18', color: cat.color }}>
                    <i className={`fa ${cat.icon}`}></i>
                  </div>
                  <div className="cat-info">
                    <h6>{cat.label}</h6>
                    <span>{cat.count} Vacancies</span>
                  </div>
                  <i className="fa fa-arrow-right cat-arrow"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About */}
      <section className="section-pad">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="about-grid">
                <div className="about-img-wrap main"><img src={about1} alt="" /></div>
                <div className="about-img-wrap top-right"><img src={about2} alt="" /></div>
                <div className="about-img-wrap bottom-left"><img src={about3} alt="" /></div>
                <div className="about-img-wrap bottom-right"><img src={about4} alt="" /></div>
                <div className="about-badge-card">
                  <i className="fa fa-trophy"></i>
                  <div><strong>#1 Job Portal</strong><span>2024 Award</span></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <span className="section-badge">About Us</span>
              <h2 className="section-title mt-2">We Help You Get The Best Job & Find Top Talent</h2>
              <p className="text-muted mb-4" style={{ lineHeight: 1.8 }}>
                JobEntry connects ambitious professionals with world-class companies. Whether you're looking for your next big opportunity or searching for the perfect hire, we make the process seamless, fast, and effective.
              </p>
              <div className="about-features">
                {[
                  { icon: 'fa-bolt',       color: '#0066FF', text: 'Instant job matching with AI-powered recommendations' },
                  { icon: 'fa-shield-alt', color: '#00C896', text: 'Verified companies and trusted job listings only' },
                  { icon: 'fa-bell',       color: '#f59e0b', text: 'Real-time alerts for jobs that match your profile' },
                ].map((f, i) => (
                  <div className="about-feature" key={i}>
                    <div className="about-feature-icon" style={{ background: f.color + '18', color: f.color }}>
                      <i className={`fa ${f.icon}`}></i>
                    </div>
                    <p>{f.text}</p>
                  </div>
                ))}
              </div>
              <div className="about-cta">
                <Link to="/about" className="btn-grad">Learn More <i className="fa fa-arrow-right ms-2"></i></Link>
                <Link to="/contact" className="btn-outline-grad">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Job Listings */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Latest Openings</span>
            <h2 className="section-title">Featured Job Listings</h2>
            <p className="section-sub">Hand-picked opportunities from top companies worldwide</p>
          </div>
          <div className="job-tabs">
            {tabs.map((t, i) => (
              <button key={i} className={`job-tab-btn ${activeTab === i ? 'active' : ''}`} onClick={() => setActiveTab(i)}>{t}</button>
            ))}
          </div>
          <div className="jobs-list">
            {filtered.length > 0 ? filtered.map((job, i) => (
              <div className="job-card-pro" key={i}>
                <div className="job-card-left">
                  <div className="job-logo-wrap"><img src={job.logo} alt="" /></div>
                  <div className="job-info">
                    <div className="job-top-row">
                      <h5>{job.title}</h5>
                      <span className={`job-tag tag-${job.tag.toLowerCase()}`}>{job.tag}</span>
                    </div>
                    <div className="job-meta">
                      <span><i className="fa fa-map-marker-alt"></i> {job.location}</span>
                      <span><i className="far fa-clock"></i> {job.type}</span>
                      <span><i className="far fa-money-bill-alt"></i> {job.salary}</span>
                      <span><i className="far fa-calendar-alt"></i> {job.deadline}</span>
                    </div>
                  </div>
                </div>
                <div className="job-card-right">
                  <button className="job-save-btn"><i className="far fa-heart"></i></button>
                  <Link to="/job-detail" className="job-apply-btn">Apply Now <i className="fa fa-arrow-right ms-1"></i></Link>
                </div>
              </div>
            )) : <p className="text-center text-muted py-4">No jobs found.</p>}
          </div>
          <div className="text-center mt-5">
            <Link to="/job-list" className="btn-grad px-5 py-3">Browse All Jobs <i className="fa fa-arrow-right ms-2"></i></Link>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Take the Next Step?</h2>
              <p>Join over 120,000 professionals who found their dream job through JobEntry.</p>
            </div>
            <div className="cta-right">
              <Link to="/login" className="cta-btn-white">Get Started Free</Link>
              <Link to="/job-list" className="cta-btn-outline">Browse Jobs</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Testimonials</span>
            <h2 className="section-title">What Our Users Say</h2>
            <p className="section-sub">Real stories from real people who found success with JobEntry</p>
          </div>
          <Slider {...testimonialSettings}>
            {testimonials.map((t, i) => (
              <div key={i} className="px-2">
                <div className="testi-card">
                  <div className="testi-stars">
                    {[...Array(5)].map((_, j) => <i key={j} className="fa fa-star"></i>)}
                  </div>
                  <p className="testi-text">"{t.text}"</p>
                  <div className="testi-author">
                    <img src={t.img} alt="" />
                    <div>
                      <strong>{t.name}</strong>
                      <span>{t.profession}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <span className="section-badge">Contact Us</span>
              <h2 className="section-title mt-2">Get In Touch With Us</h2>
              <p className="text-muted mb-4" style={{ lineHeight: 1.8 }}>Have a question or need help? Our team is ready to assist you. Reach out and we'll respond within 24 hours.</p>
              <div className="d-flex flex-column gap-3 mb-4">
                <a href="https://maps.google.com/?q=D-184+Sector-63+Noida+UP+201301" target="_blank" rel="noreferrer" className="d-flex align-items-center gap-3" style={{ textDecoration: 'none' }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: '#e8f0ff', color: '#0066FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                    <i className="fa fa-map-marker-alt"></i>
                  </div>
                  <span style={{ fontSize: 14, color: '#555' }}>D-184, Sector-63, Noida, UP - 201301</span>
                </a>
                <a href="tel:+919718094931" className="d-flex align-items-center gap-3" style={{ textDecoration: 'none' }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: '#e6fff6', color: '#00C896', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                    <i className="fa fa-phone-alt"></i>
                  </div>
                  <span style={{ fontSize: 14, color: '#555' }}>+91 97180 94931</span>
                </a>
                <a href="mailto:onexvorabusinesssolutions@gmail.com" className="d-flex align-items-center gap-3" style={{ textDecoration: 'none' }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: '#fff8e6', color: '#f59e0b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                    <i className="fa fa-envelope"></i>
                  </div>
                  <span style={{ fontSize: 14, color: '#555' }}>onexvorabusinesssolutions@gmail.com</span>
                </a>
              </div>
              <Link to="/contact" className="btn-outline-grad">Visit Contact Page <i className="fa fa-arrow-right ms-2"></i></Link>
            </div>
            <div className="col-lg-7">
              <div className="home-contact-form">
                <h5 className="mb-4" style={{ fontWeight: 700, color: '#0A1628' }}>Send Us a Message</h5>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="contact-input-wrap">
                      <i className="fa fa-user"></i>
                      <input type="text" placeholder="Your Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="contact-input-wrap">
                      <i className="fa fa-envelope"></i>
                      <input type="email" placeholder="Your Email" />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="contact-input-wrap">
                      <i className="fa fa-tag"></i>
                      <input type="text" placeholder="Subject" />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="contact-input-wrap textarea">
                      <i className="fa fa-comment-alt"></i>
                      <textarea rows="4" placeholder="Your message..."></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="contact-submit-btn">
                      <i className="fa fa-paper-plane me-2"></i> Send Message
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
